import {docReady,loadColors} from "./utils";
import pie from "./pie";
import bars from "./bars";
import menu from "./menu";
import "@babel/polyfill";
import * as d3 from "d3";

window.runKoa = function(resourceUrl, enableMenu = true,options,option2) {
    const colorsRq = loadColors('colors.ddxml');
    const barsRq = fetch(resourceUrl+'cc_percent.jsonv').then(resp => resp.json());
    const pieRq = fetch(resourceUrl+'cc_seats.jsonv').then(resp => resp.json());
    return Promise.all([colorsRq, barsRq,pieRq]).then(([colors, barsData,pieData])=>{
        pie('#calc',colors,pieData, options);
        if(enableMenu){
            menu(barsData.category,'#menu',function (toggle){
                d3.select('svg').selectAll("*").remove()
                if(toggle){
                    pie('#calc',colors,pieData,options);
                    d3.select('.koa-menu-text').style('display','inline-block');
                }
                else{
                    bars('#calc',colors,barsData,option2);
                    d3.select('.koa-menu-text').style('display','none');
                }
            });
        }
        else{
            bars('#calc2',colors,barsData,option2);
        }
    }).catch(_=> {
        const regio = window.defStudi.studio.includes('br24');
        if(!regio){
            const child = $('#calc');
            const parent =  $('#calc').parent();
            child.remove();
            parent.append(`<img width="1440px" height="810px" class="imageCls unselectable" src="./resources/teaser/koalitionsrechner.jpg" alt="Hinweisgrafik, dass der Koalitionsrechner zur Bundestagswahl 2021 erst am Wahlsonntag ab 18 Uhr zur Verfügung steht" >`);
        }
        else{
            $('#votes').remove();
            const pieRq = fetch('preview_seats.jsonv').then(resp => resp.json());
            return Promise.all([colorsRq,pieRq]).then(([colors,pieData])=>{
                pie('#calc',colors,pieData, options);
                d3.selectAll(".legendBar").on('click',null);
                d3.selectAll(".legendBar").attr('tabindex',null);
                d3.selectAll(".legendBar .number").remove();
                return true;
            });
        }
    });
    // load data

}
// Only for testing
/*docReady(function (){
    runKoa('resources/'); // run with it
});*/
